module.exports = __webpack_public_path__ + "img/easypass_prod.02a282f4.png";